{
  "name": "@delta-base/observability",
  "version": "0.0.2",
  "description": "Observability framework for delta-base applications",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    },
    "./scripts/*": {
      "require": "./dist/scripts/*.js"
    }
  },
  "bin": {
    "collect-build-info": "./dist/scripts/collect-build-info.js"
  },
  "files": [
    "dist",
    "LICENSE",
    "README.md"
  ],
  "scripts": {
    "typecheck": "tsc --noEmit",
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "vitest run --passWithNoTests",
    "test:watch": "vitest",
    "prepublishOnly": "pnpm run build"
  },
  "keywords": [
    "delta-base",
    "observability",
    "opentelemetry",
    "tracing",
    "monitoring",
    "logging"
  ],
  "author": "Nibbio LLC",
  "license": "LicenseRef-LICENSE",
  "repository": {
    "type": "git",
    "url": "https://github.com/nibbio-co/delta-base.git",
    "directory": "packages/libs/deltabase/observability"
  },
  "dependencies": {
    "@delta-base/toolkit": "workspace:*",
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/sdk-trace-base": "^1.30.1",
    "hono": "catalog:",
    "zod": "catalog:"
  },
  "devDependencies": {
    "@types/node": "^20.0.0",
    "@hono/zod-openapi": "catalog:",
    "tsup": "^8.3.6",
    "typescript": "^5.0.0",
    "vitest": "^3.1.1"
  },
  "peerDependencies": {
    "@hono/zod-openapi": "^0.17.1"
  },
  "peerDependenciesMeta": {
    "@hono/zod-openapi": {
      "optional": true
    }
  },
  "engines": {
    "node": ">=16.0.0"
  },
  "publishConfig": {
    "access": "public"
  },
  "sideEffects": false
}
